import TermsAndConditionsApp from "@/_roots/termsAndConditions/TermsAndConditionsApp.vue";
import VueInstance from "@/main";

VueInstance(TermsAndConditionsApp);
